module.exports = __webpack_public_path__ + "static/media/preview.06b97fce.png";